import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';

import { fillInstoreCuratedOffersHeading } from '../actions';

import { selectInstoreOffersConfig } from '../../OffersSection/selectors';

import {
  selectInstoreCuratedOffersHeadingIsLoading,
  selectInstoreCuratedOffersHeadingIsLoaded,
  selectInstoreCuratedOffersHeadingData,
} from '../selectors';

export const useGetHeading = () => {
  const dispatch = useDispatch();
  const config = useSelector(selectInstoreOffersConfig);
  const isLoading = useSelector(selectInstoreCuratedOffersHeadingIsLoading);
  const isLoaded = useSelector(selectInstoreCuratedOffersHeadingIsLoaded);
  const headingData = useSelector(selectInstoreCuratedOffersHeadingData);

  const { shouldFetchHeadingFromAPI, sectionTitle } = config;

  useEffect(() => {
    // use hardcoded non-api-provided heading
    if (!shouldFetchHeadingFromAPI) {
      dispatch(fillInstoreCuratedOffersHeading({ sectionTitle }));
      return;
    }

    // use api-provided heading
    if (!isLoaded && !isLoading) {
      const { headingApi: { params, options } } = config;
      dispatch(fetchPlacements(params, options));
    }
  }, []);

  return {
    isLoaded,
    isLoading,
    headingData,
  };
};
